export default __webpack_public_path__ + "static/media/188-south africa.48ce32af.svg";